module.exports = __webpack_public_path__ + "img/default.7a946d9b.png";